import { render, staticRenderFns } from "./DashboardSetupConfig.vue?vue&type=template&id=75b14d34&scoped=true&"
import script from "./DashboardSetupConfig.vue?vue&type=script&lang=js&"
export * from "./DashboardSetupConfig.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSetupConfig.vue?vue&type=style&index=0&id=75b14d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b14d34",
  null
  
)

export default component.exports